export default __webpack_public_path__ + "static/media/detail_mobile_4_3.78f85c55.png";